// extracted by mini-css-extract-plugin
module.exports = {"notesTextarea":"styles_notesTextarea__O1x3_"};